import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from 'react';
import { connect, useDispatch } from 'react-redux';
import { Checkbox, Dropdown } from 'antd';
// import { PlusCircleOutlined } from '@ant-design/icons'; // used by the disabled table-header "+" button

import TaskFilter from './TaskFilter/TaskFilter.jsx';
import AssigneeIcon from './TaskFilter/Icons/Assignee.jsx';

import UserIcon from './TaskFilter/Icons/UserIcon';
import HighPriorityIcon from './TaskFilter/Icons/HighPriority';
import MediumPriorityIcon from './TaskFilter/Icons/MediumPriority';
import LowPriorityIcon from './TaskFilter/Icons/LowPriority';
import LowestPriorityIcon from './TaskFilter/Icons/LowestPriority';
import PriorityIcon from './TaskFilter/Icons/Priority';
import CraetorIcon from './TaskFilter/Icons/Creator';
import ProjectIcon from './TaskFilter/Icons/Project';
import ResolutionIcon from './TaskFilter/Icons/Resolution';
import LabelIcon from './TaskFilter/Icons/Label';

import { FormattedMessage, useIntl } from 'react-intl';
import {
  getUserTasksAction,
  loadCachedUserTasks,
  setUserTasksFiltersAction,
} from '../../../../redux/tasks/actions.js';
import { ACTION_TYPES as TASKS_ACTION_TYPES } from '../../../../redux/tasks/constants.js';
import {
  getTasksCustomFiltersSelector,
  getUserTasksCount,
  getUserTasksFilters,
  getUserTasksHasMore,
  getUserTasksIdList,
  getUserTasksPage,
} from '../../../../redux/general/selectors.js';
import ConnectedTaskTitle from '../task-components/primitive-connected-task-components/ConnectedTaskTitle.jsx';
import ConnectedTaskTitleIdentifier from '../task-components/primitive-connected-task-components/ConnectedTaskTitleIdentifier.jsx';
import ConnectedPriorityDropdown from '../task-components/primitive-connected-task-components/ConnectedPriorityDropdown.jsx';
import ConnectedCalendarDropdown from '../task-components/ConnectedCalendarDropdown.jsx';
import ConnectedAssigneeSelect from '../task-components/ConnectedAssigneeSelect.jsx';
import ConnectedTaskCreated from '../task-components/primitive-connected-task-components/ConnectedTaskCreated.jsx';
import ConnectedTaskUpdated from '../task-components/primitive-connected-task-components/ConnectedTaskUpdated.jsx';
import MarkCompleteButton from '../task-components/primitive-connected-task-components/MarkCompleteButton.jsx';
import ConnectedTaskProjectsLabelList from '../task-components/primitive-connected-task-components/task-projects-label-list/ConnectedTaskProjectsLabelList.jsx';
import ConnectedTaskCustomField from '../task-components/primitive-connected-task-components/ConnectedTaskCustomField.jsx';
import {
  saveCustomTasksFilterAction,
  editCustomTasksFilterAction, // editUsersCustomFilter
  deleteCustomTasksFilterAction, // deleteUsersCustomFilter
} from '../../../../redux/general/actions.js';
import { Divider } from '@mui/material';
import {
  getProjectsCFsMatchingWorkspaceCFs,
  getWorkspaceCustomFields,
  isWorkspaceAdminOrOwnerSelector,
} from '../../../../redux/workspace/selectors.js';

import './myTasksStyle.css';
import { useGetCustomFiltersQuery } from '../../../../services/tasksApi.js';
import TaskContextMenuDropdown from '../../atoms/menu/TaskContextMenuDropdown.jsx';
import { useSearchParams } from 'react-router-dom';
import { useDisclosure } from '@mantine/hooks';
import ExportDataModal from '../../organisms/ExportDataModal/ExportDataModal.jsx';
import { isEmpty } from 'lodash';
import TasksVirtualizedTable from './TasksVirtualizedTable.jsx';

const defaultColumns = [
  {
    title: <div className="text-center w-full">✓</div>,
    menuLabel: <FormattedMessage id="COMPLETED" defaultMessage="Completed" />,
    width: 40,
    minWidth: 40,
    dataIndex: 'action',
    key: 'operation',
    fixed: 'left',
  },
  {
    title: (
      <div className="text-center">
        <FormattedMessage id="ID" defaultMessage="ID" />
      </div>
    ),
    width: 130,
    minWidth: 130,
    dataIndex: 'id',
    key: 'id',
    fixed: 'left',
  },
  {
    title: <FormattedMessage id="TASK_NAME" defaultMessage="Task Name" />,
    dataIndex: 'title',
    key: 'title',
    width: 400,
    minWidth: 200,
    lightweight: true, // Plain text is cheap enough to render real while scrolling
  },
  {
    title: (
      <div className="text-center">
        <FormattedMessage id="ASSIGNEE" defaultMessage="Assignee" />
      </div>
    ),
    dataIndex: 'assignee',
    key: '1',
    width: 120,
    minWidth: 120,
  },
  {
    title: (
      <div className="text-center">
        <FormattedMessage id="DATE" defaultMessage="Date" />
      </div>
    ),
    dataIndex: 'date',
    key: '2',
    width: 160,
    minWidth: 160,
  },
  {
    title: (
      <div className="text-center">
        <FormattedMessage id="PRIORITY" defaultMessage="Priority" />
      </div>
    ),
    dataIndex: 'priority',
    key: '3',
    width: 160,
    minWidth: 160,
  },
  {
    title: <FormattedMessage id="PROJECTS" defaultMessage="Projects" />,
    dataIndex: 'project',
    key: '8',
    width: 200,
    minWidth: 160,
  },
  // {
  //   title: <FormattedMessage id="SECTION" defaultMessage="Section" />,
  //   dataIndex: 'section',
  //   key: '9',
  // },
  // { title: 'Comments', dataIndex: 'comments', key: '10', width: 200, },
  // { title: 'Subtasks', dataIndex: 'subtasks', key: '11', width: 200 },
  {
    title: (
      <div className="text-center">
        <FormattedMessage id="CREATED" defaultMessage="Created" />
      </div>
    ),
    dataIndex: 'created',
    key: '12',
    width: 120,
    minWidth: 120,
  },
  {
    title: (
      <div className="text-center">
        <FormattedMessage id="UPDATED_FILTER" defaultMessage="Updated" />
      </div>
    ),
    dataIndex: 'updated',
    key: '13',
    width: 120,
    minWidth: 120,
  },
];

const normalizeFilterKey = (filter) => {
  if (!filter || typeof filter !== 'object') return 'EMPTY';
  const cleaned = {};
  Object.keys(filter)
    .sort()
    .forEach((k) => {
      const v = filter[k];
      if (v == null || v === '') return;
      if (Array.isArray(v) && v.length === 0) return;
      if (typeof v === 'object' && !Array.isArray(v) && Object.keys(v).length === 0) return;
      cleaned[k] = v;
    });
  return Object.keys(cleaned).length === 0 ? 'EMPTY' : JSON.stringify(cleaned);
};

const TaskFilterSkeleton = () => (
  <div className="w-full task-filter shadow mb-1">
    <div className="w-full flex items-center gap-2 px-4 h-11 bg-white border-b border-gray-100">
      {[40, 42, 58].map((w, i) => (
        <div
          key={i}
          className="h-7 px-3 rounded-md border border-gray-200 bg-white flex items-center gap-1.5 flex-shrink-0"
        >
          <div className="h-3 w-3 rounded-sm bg-gray-100 animate-pulse" />
          <div className="h-2.5 rounded bg-gray-100 animate-pulse" style={{ width: w }} />
        </div>
      ))}
      <div className="h-2.5 w-9 rounded bg-gray-100 animate-pulse ml-1 flex-shrink-0" />
      <div className="h-2.5 w-14 rounded bg-gray-100 animate-pulse flex-shrink-0" />
    </div>
  </div>
);

const FILTER_PARAM_KEYS = new Set([
  'projects',
  'resolution',
  'assignedTo',
  'priority',
  'creator',
  'dueDate',
  'dueStartDate',
  'dueEndDate',
  'tags',
  'status',
  'includeTasksWithoutDueDate',
  'filterId',
]);
const hasActiveUrlFilters = (searchParams) =>
  [...searchParams.keys()].some(
    (k) => FILTER_PARAM_KEYS.has(k) || /^[a-f\d]{24}$/i.test(k),
  );

const MyTasks = (props) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const {
    userTasksIdList,
    workspaceFilter,
    userFilters,
    tasksCustomFilters, // usersCustomFilters
    userTasksPage,
    userTasksCount,
    userTasksHasMore,
    currentWorkspace,
    // projectsCustomFields,
    workspaceCustomFields,
    isTaskOpen,
    isWorkspaceAdminOrOwner,
    taskEntities,
  } = props;

  const workspaceId = localStorage.getItem('workspaceId');
  const [searchParams] = useSearchParams();
  const hasUrlFilters = hasActiveUrlFilters(searchParams);

  const {
    data: usersCustomFiltersData,
    refetch: refetchCustomFilters,
    isSuccess: getCustomFiltersIsSuccess,
  } = useGetCustomFiltersQuery({
    workspaceId,
  });

  const [selectedLabels, setSelectedLabels] = useState([]);
  const [filteredTasksIds, setFilteredTasksIds] = useState(
    userTasksIdList || [],
  );
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState();
  const [
    selectedTasksCustomFilters, //selectedUsersCustomFilter, // TODO: not used
    setSelectedTasksCustomFilters, // setSelectedUsersCustomFilter
  ] = useState(null);
  const [isExportModalOpen, { toggle: toggleExportModal }] = useDisclosure();
  const [isFilterApplying, setIsFilterApplying] = useState(true);
  const [isPaginationLoading, setIsPaginationLoading] = useState(false);

  const [windowWidth, setWindowWidth] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth : 1280,
  );
  useEffect(() => {
    const onResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  const fixedColumns = windowWidth >= 1024;

  const _appliedFilters = useRef({});
  const _internals = useRef({});

  const setAppliedFilters = useCallback((filters) => {
    _appliedFilters.current = filters;
  }, []);

  const handleLabelSelection = async (filters) => {
    const key = normalizeFilterKey(filters);
    // applyFilters() optimistically flips the loading flag on every filter
    // interaction. When the resulting filter state is unchanged (e.g. toggling
    // a due-date preset off then landing on the same key) no fetch runs, so we
    // must clear the flag here or the page stays stuck loading.
    if (_internals.current.lastFetchKey === key) {
      setIsFilterApplying(false);
      return;
    }
    _internals.current.lastFetchKey = key;

    dispatch(
      setUserTasksFiltersAction({
        ...filters,
      }),
    );

    if (JSON.stringify(filters) != JSON.stringify(userFilters)) {
      setIsFilterApplying(true);
      await dispatch(
        getUserTasksAction({
          ...filters,
        }),
      );
      setIsFilterApplying(false);
    } else {
      setIsFilterApplying(false);
    }
  };

  const getPriorityData = (p) => {
    const priorityTextMap = {
      p1: { text: 'P1', icon: <HighPriorityIcon />, altText: 'Critical' },
      p2: { text: 'P2', icon: <MediumPriorityIcon />, altText: 'High' },
      p3: { text: 'P3', icon: <LowPriorityIcon />, altText: 'Medium' },
      p4: { text: 'P4', icon: <LowestPriorityIcon />, altText: 'Low' },
    };

    return priorityTextMap[p];
  };

  const fetchTasks = useCallback(async () => {
    const key = normalizeFilterKey(workspaceFilter?.query);
    if (_internals.current.lastFetchKey === key) return;
    _internals.current.lastFetchKey = key;
    setIsFilterApplying(true);
    await dispatch(getUserTasksAction(workspaceFilter?.query));
    setIsFilterApplying(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspaceFilter?.query]);

  useEffect(() => {
    if (workspaceFilter === null || workspaceFilter === undefined) return;

    const hasSavedFilter =
      workspaceFilter && Object.keys(workspaceFilter).length > 0;

    if (hasSavedFilter) {
      const selectedFilter = workspaceFilter;
      const labels = selectedFilter?.labels || [];
      const updatedLabels = labels?.map((label) => {
        switch (label?.type) {
          case 'Priority':
            const pData = getPriorityData(label?.id);
            return {
              ...label,
              icon: pData?.icon,
              parentIcon: <PriorityIcon />,
            };

          case 'Creator':
          case 'Assignee':
            return {
              ...label,
              icon: <UserIcon avi={label?.avi} />,
              parentIcon:
                label?.type === 'Creator' ? <CraetorIcon /> : <AssigneeIcon />,
            };

          case 'Project':
            return {
              ...label,
              parentIcon: <ProjectIcon />,
            };

          case 'Resolution':
            return {
              ...label,
              parentIcon: <ResolutionIcon />,
            };

          case 'customField':
            return {
              ...label,
              parentIcon: <LabelIcon />,
            };

          default:
            return label;
        }
      });

      setSelectedLabels(updatedLabels);
      setSelectedTasksCustomFilters(null);
      dispatch(setUserTasksFiltersAction(workspaceFilter?.query));
    }

    if (!hasUrlFilters) {
      fetchTasks();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspaceFilter]);

  // NOTE: removed a duplicate fetch of this same endpoint here
  // (getCustomTasksFiltersAction) — its result was unused, filters render from
  // useGetCustomFiltersQuery above.

  useEffect(() => {
    if (!dropdownVisible) return undefined;
    const close = () => setDropdownVisible(false);
    document.addEventListener('scroll', close, true);
    return () => document.removeEventListener('scroll', close, true);
  }, [dropdownVisible]);

  useEffect(() => {
    dispatch({ type: TASKS_ACTION_TYPES.CLEAR_USER_TASKS });
    dispatch(loadCachedUserTasks());
    if (!workspaceFilter && !hasUrlFilters) {
      fetchTasks();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (userTasksIdList !== filteredTasksIds) {
      setFilteredTasksIds(userTasksIdList);
    }
  }, [userTasksIdList, filteredTasksIds]);

  const loadMoreUserTasks = useCallback(async () => {
    if (isFilterApplying) return;
    const hasMore =
      userTasksHasMore !== false &&
      (!userTasksCount || filteredTasksIds?.length < userTasksCount);
    if (
      !hasMore ||
      _internals.current.isFetchingTasks ||
      !(filteredTasksIds?.length > 40)
    ) {
      return;
    }
    _internals.current.isFetchingTasks = true;
    setIsPaginationLoading(true);
    try {
      await dispatch(
        getUserTasksAction(
          userFilters,
          (userTasksPage || 0) + 1,
          undefined,
          userTasksCount,
        ),
      );
    } catch (e) {
    } finally {
      _internals.current.isFetchingTasks = false;
      setIsPaginationLoading(false);
    }
  }, [
    isFilterApplying,
    userTasksCount,
    userTasksHasMore,
    filteredTasksIds?.length,
    userFilters,
    userTasksPage,
    dispatch,
  ]);

  const handleSaveUserFilter = (selectedFilters, filterName, cb) => {
    dispatch(
      saveCustomTasksFilterAction(selectedFilters, filterName, intl, cb),
    );
  };

  // Formerly handleEditUsersCustomFilter
  const handleEditTasksCustomFilter = (filter, filterName, cb) => {
    dispatch(editCustomTasksFilterAction(filter, filterName, cb));
  };

  // Formerly handleDeleteUsersCustomFilter
  const handleDeleteTasksCustomFilter = (filter) => {
    dispatch(deleteCustomTasksFilterAction(filter._id));
  };

  const skeletonSource = useMemo(() => {
    const customKeySkeleton = {};
    workspaceCustomFields?.forEach((cf) => {
      customKeySkeleton[cf._id] = <div className="h-2.5 w-12 bg-gray-100 rounded animate-pulse" />;
    });
    const widths = [160, 220, 140, 200, 180, 120, 250, 170, 130, 210];
    return Array.from({ length: 10 }, (_, i) => ({
      key: `skeleton-${i}`,
      id: <div className="h-2.5 w-14 bg-gray-100 rounded animate-pulse mx-auto" />,
      title: <div className="h-2.5 bg-gray-100 rounded animate-pulse" style={{ width: widths[i] }} />,
      assignee: <div className="h-6 w-6 bg-gray-100 rounded-full animate-pulse mx-auto" />,
      date: <div className="h-2.5 w-16 bg-gray-100 rounded animate-pulse mx-auto" />,
      priority: <div className="h-2.5 w-14 bg-gray-100 rounded animate-pulse mx-auto" />,
      project: <div className="h-2.5 w-20 bg-gray-100 rounded animate-pulse" />,
      created: <div className="h-2.5 w-14 bg-gray-100 rounded animate-pulse mx-auto" />,
      updated: <div className="h-2.5 w-14 bg-gray-100 rounded animate-pulse mx-auto" />,
      action: <div className="h-4 w-4 bg-gray-100 rounded-full animate-pulse mx-auto" />,
      ...customKeySkeleton,
    }));
  }, [workspaceCustomFields]);

  const rowCacheRef = useRef(new Map());
  const lastCustomFieldsKeyRef = useRef(null);

  const dataSource = useMemo(() => {
    if (!filteredTasksIds) return [];

    // Invalidate the cache if the custom-field schema changed.
    const cfKey = (workspaceCustomFields || [])
      .map((cf) => cf?._id)
      .join('|');
    if (cfKey !== lastCustomFieldsKeyRef.current) {
      rowCacheRef.current = new Map();
      lastCustomFieldsKeyRef.current = cfKey;
    }

    const cache = rowCacheRef.current;

    return filteredTasksIds
      .filter((id) => id && !isEmpty(taskEntities[id]))
      .map((taskId) => {
        const cached = cache.get(taskId);
        if (cached) return cached;

        const customKeys = {};
        workspaceCustomFields?.forEach((customField) => {
          customKeys[customField._id] = (
            <ConnectedTaskCustomField
              customFieldId={customField._id}
              projectId={customField.projectId}
              taskId={taskId}
              isWorkspaceCustomField
            />
          );
        });

        const row = {
          key: taskId,
          id: <ConnectedTaskTitleIdentifier taskId={taskId} />,
          title: <ConnectedTaskTitle taskId={taskId} />,
          priority: <ConnectedPriorityDropdown taskId={taskId} />,
          action: (
            <div className="flex justify-center w-full">
              <MarkCompleteButton taskId={taskId} />
            </div>
          ),
          project: <ConnectedTaskProjectsLabelList taskId={taskId} />,
          created: <ConnectedTaskCreated taskId={taskId} />,
          updated: <ConnectedTaskUpdated taskId={taskId} />,
          assignee: (
            <div className="flex justify-center w-full">
              <ConnectedAssigneeSelect iconSize={26} taskId={taskId} count={2} />
            </div>
          ),
          date: (
            <div className="relative px-3 flex justify-center">
              <ConnectedCalendarDropdown isLarge taskId={taskId} />
            </div>
          ),
          ...customKeys,
        };
        cache.set(taskId, row);
        return row;
      });
  }, [filteredTasksIds, taskEntities, workspaceCustomFields]);

  const columnsWithCustomFields = useMemo(
    () => [
      ...defaultColumns.map((col) =>
        fixedColumns ? col : { ...col, fixed: undefined },
      ),
      ...workspaceCustomFields?.map((field) => ({
        title: (
          <div className="project-custom-field-title-container">
            <div className="project-custom-field-title-container-title">
              {field?.name}
            </div>
          </div>
        ),
        width: 190,
        minWidth: 190,
        dataIndex: field?._id,
        key: field?._id,
      })),
    ],
    [workspaceCustomFields, fixedColumns],
  );

  // By default only the built-in columns are shown; workspace custom fields
  // start hidden until the user opts into them.
  const defaultCheckedList = useMemo(
    () => defaultColumns.map((item) => item.key),
    [],
  );

  // Column visibility is remembered per workspace and resets to defaults when
  // the user switches workspace.
  const workspaceColumnsKey = currentWorkspace?._id;

  const readStoredCheckedList = useCallback(() => {
    if (typeof window === 'undefined' || !workspaceColumnsKey) {
      return defaultCheckedList;
    }
    const stored = localStorage.getItem(
      `my-tasks-checkedList-${workspaceColumnsKey}`,
    );
    if (!stored) return defaultCheckedList;
    try {
      return JSON.parse(stored);
    } catch (err) {
      return defaultCheckedList;
    }
  }, [workspaceColumnsKey, defaultCheckedList]);

  const [checkedList, setCheckedList] = useState(readStoredCheckedList);

  // Reload the saved selection (or fall back to defaults) on workspace change.
  const lastWorkspaceColumnsKeyRef = useRef(workspaceColumnsKey);
  useEffect(() => {
    if (lastWorkspaceColumnsKeyRef.current === workspaceColumnsKey) return;
    lastWorkspaceColumnsKeyRef.current = workspaceColumnsKey;
    setCheckedList(readStoredCheckedList());
  }, [workspaceColumnsKey, readStoredCheckedList]);

  const persistCheckedList = useCallback(
    (next) => {
      setCheckedList((prev) => {
        const value = typeof next === 'function' ? next(prev) : next;
        if (typeof window !== 'undefined' && workspaceColumnsKey) {
          localStorage.setItem(
            `my-tasks-checkedList-${workspaceColumnsKey}`,
            JSON.stringify(value),
          );
        }
        return value;
      });
    },
    [workspaceColumnsKey],
  );

  const options = useMemo(
    () =>
      columnsWithCustomFields?.map(({ key, title, menuLabel }) => ({
        label: menuLabel || title,
        value: key,
      })),
    [columnsWithCustomFields],
  );

  const tableColumns = useMemo(
    () =>
      columnsWithCustomFields?.map((item) => ({
        ...item,
        hidden: !checkedList.includes(item.key),
      })),
    [checkedList, columnsWithCustomFields],
  );

  const applyFilters = useCallback(() => {
    setIsFilterApplying(true);
  }, []);

  // Shared add/remove-column menu, used by both the toolbar "Columns" button
  // and the "+" control in the table header.
  const renderColumnsMenu = useCallback(
    () => (
      <div className="bg-white border border-gray-200 rounded-xl shadow-xl overflow-hidden" style={{ width: 220 }}>
        <div className="px-4 py-2.5 border-b border-gray-100 flex items-center justify-between">
          <span className="text-[11px] font-semibold text-gray-400 uppercase tracking-wider">Columns</span>
          <button
            className="text-xs text-blue-600 hover:text-blue-700 font-medium"
            onClick={() => persistCheckedList(options.map((opt) => opt.value))}
          >
            Show all
          </button>
        </div>
        <div className="py-1 max-h-[50vh] overflow-y-auto">
          <Checkbox.Group value={checkedList} onChange={persistCheckedList} className="w-full">
            {options.map((opt) => (
              <label key={opt.value} className="flex items-center gap-2.5 px-4 py-2 hover:bg-gray-50 cursor-pointer w-full">
                <Checkbox value={opt.value} />
                <span className="text-sm text-gray-700 truncate">{opt.label}</span>
              </label>
            ))}
          </Checkbox.Group>
        </div>
        <div className="px-4 py-2 border-t border-gray-100 flex justify-end">
          <button
            className="text-xs text-gray-400 hover:text-gray-600 font-medium"
            onClick={() => persistCheckedList([])}
          >
            Hide all
          </button>
        </div>
      </div>
    ),
    [checkedList, options, persistCheckedList],
  );

  // Disabled in favor of the toolbar "Columns" button. Kept for reference.
  // const columnsHeaderButton = (
  //   <Dropdown trigger={['click']} dropdownRender={renderColumnsMenu}>
  //     <div className="mtv-add-column-btn" title="Add or remove columns">
  //       <PlusCircleOutlined />
  //     </div>
  //   </Dropdown>
  // );

  return (
    <div
      className="flex flex-col h-full w-full bg-white"
    >
      {/* Filters */}
      {props.users.length &&
      currentWorkspace?.myProjects &&
      getCustomFiltersIsSuccess ? (
        <TaskFilter
          users={props.users}
          projects={currentWorkspace?.myProjects}
          onLabelSelection={handleLabelSelection}
          handleSaveUserFilter={handleSaveUserFilter}
          usersCustomFilters={usersCustomFiltersData?.data || []}
          refetchCustomFilters={refetchCustomFilters}
          onDeleteUsersCustomFilter={handleDeleteTasksCustomFilter}
          onEditUsersCustomFilter={handleEditTasksCustomFilter}
          workspaceCustomFields={workspaceCustomFields}
          setAppliedFilters={setAppliedFilters}
          applyFilters={applyFilters}
          rightActions={
            <div className="flex items-center gap-1.5 mr-2">
              {isWorkspaceAdminOrOwner && (
                <button
                  onClick={toggleExportModal}
                  className="flex items-center gap-1.5 h-7 px-3 rounded-md bg-white border border-gray-300 text-xs font-medium text-gray-700 hover:bg-gray-50 hover:border-gray-400 shadow-sm transition-all duration-150"
                >
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
                  </svg>
                  Export
                </button>
              )}
              <Dropdown trigger={['click']} dropdownRender={renderColumnsMenu}>
                <button className="flex items-center gap-1.5 h-7 px-3 rounded-md bg-white border border-gray-300 text-xs font-medium text-gray-700 hover:bg-gray-50 hover:border-gray-400 shadow-sm transition-all duration-150">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>
                  </svg>
                  Columns
                  <span className="text-[10px] font-semibold text-blue-600 bg-blue-50 rounded px-1 py-px leading-none">{checkedList.length}</span>
                </button>
              </Dropdown>
            </div>
          }
        />
      ) : (
        <TaskFilterSkeleton />
      )}
      {dropdownVisible && selectedTaskId && (
        <TaskContextMenuDropdown
          isOpen={dropdownVisible}
          isWorkspaceTasksScreen
          position={dropdownPosition}
          selectedTaskId={selectedTaskId}
          setIsEdit={setIsEdit}
          toggleDropdown={setDropdownVisible}
        />
      )}
      {/* Table */}
      <div className="flex flex-1 min-h-0 w-full px-5 py-2.5">
        {/* headerAccessory={columnsHeaderButton} disabled in favor of the toolbar "Columns" button */}
        <TasksVirtualizedTable
          columns={tableColumns}
          dataSource={dataSource}
          isLoading={isFilterApplying}
          skeletonSource={skeletonSource}
          onRowContextMenu={(taskId, event) => {
            event.preventDefault();
            setSelectedTaskId(taskId);
            setDropdownVisible(true);
            setDropdownPosition({ x: event.clientX, y: event.clientY });
          }}
          onScrollBottom={loadMoreUserTasks}
          loadingMore={isPaginationLoading}
        />
      </div>
      <ExportDataModal
        filters={_appliedFilters.current}
        isWorkspace
        open={isExportModalOpen}
        toggle={toggleExportModal}
        workspaceId={workspaceId}
      />
    </div>
  );
};

function mapStateToProps(state, props) {
  return {
    users: state.userReducer.users,
    userTasksIdList: getUserTasksIdList(state),
    userTasksPage: getUserTasksPage(state),
    userTasksCount: getUserTasksCount(state),
    userTasksHasMore: getUserTasksHasMore(state),
    teams: state.teamReducer.getTeams,
    userFilters: getUserTasksFilters(state),
    workspaceFilter: state.workspaceReducer.workspaceFilter,
    currentWorkspace: state.workspaceReducer.currentWorkspace,
    isTaskOpen: state.toggleReducer.isTicketOpen,
    tasksCustomFilters: getTasksCustomFiltersSelector(state), // Formerly usersCustomFilters
    // projectsCustomFields: getProjectsCFsMatchingWorkspaceCFs(state),
    workspaceCustomFields: getWorkspaceCustomFields(state),
    isWorkspaceAdminOrOwner: isWorkspaceAdminOrOwnerSelector(state),
    taskEntities: state.tasks?.entities || {},
  };
}

export default connect(mapStateToProps)(MyTasks);
